class Template
{
	MenuMobile()
	{
		if($(window).width() <= 1024)
		{
			const mainMenu 			= $('header#mainHeader nav#mainMenu .wrapMenu');
			const openMenu 			= $('header#mainHeader nav#mainMenu .actionMenu button.openMenu');
			const closeMenu 		= $('header#mainHeader nav#mainMenu .actionMenu button.closeMenu');
			const accordionMenu 	= $('#mainHeader nav .wrapMenu .menu-principal > li.menu-item-has-children');
					
			function OpenMenu(obj)
			{
				$('body').css({'overflow':'hidden'});
				
				obj.removeClass('activated');
				closeMenu.addClass('activated');
				mainMenu.addClass('opened');
			}

			function CloseMenu(obj)
			{
				$('body').css({'overflow':'auto'});
				
				obj.removeClass('activated');
				openMenu.addClass('activated');
				mainMenu.removeClass('opened');
			}

			openMenu.click(function()
			{
				OpenMenu($(this));
			});

			closeMenu.click(function()
			{
				CloseMenu($(this));
			});

			// openMenu.trigger('click');

			accordionMenu.each(function()
			{
				const parent 	= $(this);
				const link 		= parent.find('> a');
				const submenu 	= parent.find('ul.sub-menu');

				link.click(function(e)
				{
					e.preventDefault();

					$(this).toggleClass('Opened');
					submenu.toggleClass('Opened');
				})
			})
		}
	}

	ScrollTo()
	{
		function ScrollToElement(href)
		{
			let hash = '#'+href.split('#/')[1];
			let altura = $(hash).offset().top - 100;

			window.location = href;

			$('.scrollTo').removeClass('current-page-item');
			$(this).addClass('current-page-item');

			if(altura)
			{
				window.scroll({
					top: altura,
					behavior: 'smooth'
				});
			}
		}
		
		$('.scrollTo').each(function()
		{
			$(this).click(function(e)
			{
				e.preventDefault();

				ScrollToElement($(this).attr('href'));
			});
		});

		let HASH = window.location.hash;

		if(HASH)
		{
			ScrollToElement(HASH);
		}

	}

	static ajaxURL()
	{
		if(window.location.hostname == 'localhost')
			return '/autocomplete';
		else
			return $('body').data('domain') + '/autocomplete';
	}

	AutoComplete()
	{

		if($('.CCFormAutoCompleteSearch').length > 0)
		{
			$.ajax(
			{
				url: Template.ajaxURL(),
				dataType: 'json',
				success:function(posts)
				{
					let postsResult = [];

					// console.log(posts)

					if(posts && posts.length > 0)
					{
						posts.map((item) => {
							postsResult.push({
								title: item.title,
								media: item.media,
								permalink: item.permalink,
							});
						});
					}

					$('.CCFormAutoCompleteSearch').each(function()
					{
						const autocomplete = $(this).find('ul.boxAutoComplete');

						$(this).find(".inputSearchAutoComplete").keyup(function(e)
						{
							let val = $(this).val().toLowerCase();
							let html = '';

							if(val.length >= 3)
							{
								// console.log(val);

								postsResult.map((item,key) => 
								{
									let title = item.title.toLowerCase();

									// console.log(key)

									// console.log(title.includes(val) && key < 3 ? title : '');

									if(title.includes(val))
									{
										// console.log(title);

										html += `
											<li role="listitem">
												<a href="${item.permalink}" title="Acessar Conteúdo">
													${item.media ? `<figure><img src="${item.media}" alt="#"></figure>` : ''}
													<span class="Typography Open XSSB txColor Cinza_500">${item.title}</span>
												</a>
											</li>
										`;
									}						
								});

							}
							
							if(html.length > 0)
							{
								autocomplete.css({'display':'block'}).html(html)
							}
							else
							{
								html = '';
								autocomplete.css({'display':'none'}).html('');
							}		
						});

						$(document).click(function(event)
						{ 
							var $target = $(event.target);
							
							if(!$target.closest(autocomplete).length && autocomplete.is(":visible"))
							{
								autocomplete.css({'display':'none'});
							}        
						});
					});
				}
			});
		}
	}

	static ReturnListaCursos(init,fim,arr)
	{
		let html = '';

		arr.slice(init,fim).forEach(item => 
		{
			html += `
				<li role="listitem" class="col-12 col-sm-6 col-lg-3">
					<a href="${item.permalink}" title="Acessar Conteúdo">
						<figure><img src="${item.media}" alt="#"></figure>
						<span class="Typography Open H6B txColor Cinza_500">${item.title}</span>
					</a>
				</li>
			`;
		});

		return html;
	}

	ListaCursosAjax()
	{
		const ListaCursoAjax = $('.CCListCursosAjasx');
		const loadMore = $('.loadMorePaginacao');
		const loadMoreButton = loadMore.find('.buttonLoadMoreAjax');

		if(ListaCursoAjax.length > 0)
		{
			$.ajax(
			{
				url: Template.ajaxURL(),
				dataType: 'json',
				success:function(posts)
				{
					let postsResult = [];
					let indexInit = 0;
					let indexFim = 4;

					if(ListaCursoAjax.hasClass('lancamentos'))
					{
						posts.forEach(function(post)
						{
							if(post.acf.lancamento)
							{
								postsResult.push({
									title: post.yoast_head_json.title,
									media: post.yoast_head_json.og_image[0].url,
									permalink: post.link,
								});
							}
						});
					}
					else
					{
						posts.forEach(function(post)
						{
							postsResult.push({
								title: post.yoast_head_json.title,
								media: post.yoast_head_json.og_image[0].url,
								permalink: post.link,
							});
						});
					}

					ListaCursoAjax.html(Template.ReturnListaCursos(indexInit,indexFim,postsResult));

					if(postsResult.length > 4)
					{
						loadMore.css({'display':'block'});

						loadMoreButton.click(function()
						{
							let newIndexInit = indexFim;
							let newIndexFim = indexFim + 4;
							
							indexInit = newIndexInit;
							indexFim = newIndexFim;

							ListaCursoAjax.append(Template.ReturnListaCursos(newIndexInit,newIndexFim,postsResult))
						});
					}
				}
			});
		}			
	}

	ContactForm()
	{
		/* Validation Events for changing response CSS classes */
		document.addEventListener( 'wpcf7invalid', function( event )
		{
			$('.wpcf7-response-output').addClass('alert alert-danger');
		}, false );
		document.addEventListener( 'wpcf7spam', function( event )
		{
			$('.wpcf7-response-output').addClass('alert alert-warning');
		}, false );
		document.addEventListener( 'wpcf7mailfailed', function( event )
		{
			$('.wpcf7-response-output').addClass('alert alert-warning');
		}, false );
		document.addEventListener( 'wpcf7mailsent', function( event )
		{
			$('.wpcf7-response-output').addClass('alert alert-success');
		}, false );

		$('input.phone').mask("(00) 00000-0009", {clearIfNotMatch: true, placeholder: "(__) _____-____"});
		$('input.cep').mask("00000-000", {clearIfNotMatch: true, placeholder: "_____-___"});

		/* AUTOCOMPLETE CURSO */

		if($('#CCFormulario').length > 0)
		{
			$.ajax(
			{
				url: Template.ajaxURL(),
				dataType: 'json',
				success:function(posts)
				{
					let html = '';

					posts.forEach( function(post)
					{
						html += `<option value="${post.yoast_head_json.title}">${post.yoast_head_json.title}</option>`;
					});

					$('#curso-finalizado').append(html);
				}
			});
		}
	}

	ListaGridTabs()
	{
		const parent = $('.CCtabs');
		const selectButton = parent.find('.selectedTab');
		const selectOptionsList = parent.find('ul');

		selectButton.click(function()
        {
            selectOptionsList.toggleClass('Opened');
        });

		$(document).click(function (event) {
			if (!selectButton.is(event.target) && !selectOptionsList.is(event.target) && selectOptionsList.has(event.target).length === 0) {
				selectOptionsList.removeClass('Opened');
			}
		});
	}
	
	Share()
	{
		$('.shareContent').each(function()
		{
			const button = $(this);
			const conteudo_url = $(this).data('url');
			const conteudo_titulo = $(this).data('titulo');
			const conteudo_imagem = $(this).data('imagem');
			const conteudo_release = $(this).data('release');

			button.click(function()
			{
				if (navigator.share)
					try
					{
						const shareData = {
							title: 'Compartilhar: ' + conteudo_titulo,
							text: conteudo_release + '. Veja mais: ',
							url: conteudo_url,
						}

						// console.log(shareData)

						navigator.share(shareData);
					}
					catch (err)
					{
						console.log('Error: ', err);
					}
			})
		})
	}

	init()
	{
		const self = this;
		
		self.MenuMobile();
		self.ScrollTo();
		self.AutoComplete();
		self.ListaCursosAjax();
		self.ContactForm();
		self.ListaGridTabs();
		self.Share();

		$(window).resize(function()
		{
			self.MenuMobile();
		});		
	}
}

export default Template;